__turbopack_context__.v({
  "command_wrapper": "index-module-scss-module__-qUbKG__command_wrapper",
});
